// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.hoverClick:hover {
  opacity: 0.7;
}

body {
  background-color: #000;
}

input.text-input.text-input-ios {
  margin: 13px 8px;
  padding: 0;
  width: calc(100% - 8px - 8px);
}

input.inputItem {
  width: 100%;
  border-radius: 2px !important;
  padding-left: 5px;
  border: 0px;
}

.login-button {
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  margin-top: 8px;
}

.toggle-password-button {
  font-size: 20px;
  color: var(--ion-icon-color, #000);
}

.toggle-password-button:hover {
  color: var(--ion-color-primary);
}

.login-content {
  background: rgb(32, 39, 66);
  padding: 0px;
}
.login-content .logo-row {
  padding-top: 50px;
  padding-bottom: 20px;
}
.login-content .login-box {
  background: rgba(0, 0, 0, 0.47);
  border: 1px solid transparent;
  margin: auto;
  display: block;
  min-width: 100px;
  max-width: 400px;
  min-height: 50%;
  margin-top: -10%;
  margin-right: 5%;
  padding-bottom: 15px;
}
.login-content .custom-input-box {
  border-radius: 5px !important;
  padding-left: 5px !important;
  background: #4065ac;
}
.login-content ion-row {
  align-items: center;
  text-align: center;
}
.login-content ion-item {
  font-size: 0.9em;
  margin-bottom: 10px;
  border: 1px solid #ffffff;
  border-bottom: 0px !important;
  color: #fff;
}
.login-content .signup-col {
  margin: 0px 10px 0px 10px;
}
.login-content .inputItem {
  margin-top: 8px;
  border-radius: 2px;
  height: 40px;
  color: #000000 !important;
  font-size: 14px;
  background: rgb(255, 255, 255);
  text-align: left;
}
.login-content .item-inner {
  border-bottom-color: #ffffff !important;
}
.login-content .submit-btn {
  margin-top: 8px;
  background-color: #bb1f2d;
}
.login-content .submit-btn:hover {
  background-color: #bb1f2d !important;
  opacity: 0.7 !important;
}
.login-content .register-btn {
  color: #ffffff;
  font-size: 0.8em;
}

.password-container {
  position: relative;
  display: flex;
  align-items: center;
}

.toggle-password {
  position: absolute;
  right: 10%;
  top: 40%;
  z-index: 10;
  color: black;
  cursor: pointer;
}

.loginHeader {
  color: rgb(217, 231, 241);
  font-size: 20px;
  margin-top: 18px !important;
}

.loginLabel {
  text-align: left;
  margin-top: 15px;
  font-size: 12px;
}

.logoLogin {
  height: 40px;
}

.error-text {
  text-align: left;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.contentBackground {
  background-repeat: no-repeat;
  background-size: cover;
}

.login-base-content {
  width: 100%;
  background-color: black;
  color: white;
  text-align: left;
  padding: 3%;
  position: fixed;
  bottom: 30px;
}

.label1 {
  color: gray;
  font-size: 17px;
}

.scroll-content {
  overflow-y: inherit;
}

a[_ngcontent-c0] {
  color: #ffffff;
}

@media screen and (max-width: 500px) {
  .login-box {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
}
@media screen and (max-width: 415px) and (max-height: 815px) {
  .login-base-content {
    padding: 1% !important;
  }
  .login-base-content-right {
    display: none;
  }
  .login-base-content-left {
    width: 100% !important;
  }
  .label1 {
    font-size: 12px;
  }
  .login-content-left {
    display: none;
  }
  .login-content-right {
    width: 100%;
  }
  .login-content .login-box {
    margin-left: 15px;
  }
}
@media screen and (min-width: 416px) and (max-width: 1024px) {
  .login-base-content {
    padding: 1% !important;
  }
  .login-base-content-right {
    display: none;
  }
  .login-base-content-left {
    width: 100% !important;
  }
  .label1 {
    font-size: 16px;
  }
  .login-content-left {
    display: none;
  }
  .login-content-right {
    width: 100%;
  }
  .login-content .login-box {
    margin-top: -15%;
    margin-right: auto;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1280px) {
  .label1 {
    font-size: 14px;
  }
  .row-style {
    margin: 0px !important;
  }
}
@media screen and (width: 1024px) and (height: 1366px) {
  .login-content .login-box {
    margin-right: auto;
    max-width: 560px;
  }
}
@media screen and (max-height: 670px) {
  .login-grid {
    min-height: 400px;
  }
}
@media screen and (min-height: 671px) and (max-height: 769px) {
  .login-grid {
    min-height: 600px;
  }
}
@media screen and (min-height: 770px) and (max-height: 900px) {
  .login-grid {
    min-height: 675px;
  }
}
@media screen and (min-height: 901px) and (max-height: 1080px) {
  .login-grid {
    min-height: 750px;
  }
}
@media screen and (min-height: 1081px) and (max-height: 1200px) {
  .login-grid {
    min-height: 950px;
  }
}
@media screen and (min-height: 1201px) and (max-height: 1440px) {
  .login-grid {
    min-height: 1000px;
  }
}
@media screen and (min-height: 1441px) and (max-height: 2160px) {
  .login-grid {
    min-height: 1200px;
  }
}
@media only screen and (min-device-width: 700px) and (max-device-width: 1024px) and (orientation: landscape) {
  .grid-align {
    margin-top: calc(20% + env(safe-area-inset-top)) !important;
  }
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
  .grid-align {
    margin-top: calc(25% + env(safe-area-inset-top)) !important;
  }
  .login-base-content {
    padding: 1% !important;
  }
  .login-base-content-right {
    display: none;
  }
  .login-base-content-left {
    width: 100% !important;
  }
}
.lable-name {
  color: #dee0e1;
}

.row-style {
  margin: 0px 3% 0px 3%;
}

@media screen and (max-width: 640px) {
  .ios .mobStyle,
  .md .mobStyle {
    margin-bottom: 30px;
  }
}
.labelFont {
  font-size: smaller;
  margin-bottom: 0px !important;
}

.signInImage {
  height: 100px;
}

.header-row {
  height: 150px;
}

.signInButton {
  width: 100%;
  height: 2.8em;
}

.form-style {
  margin-bottom: 2%;
}

.grid-align {
  margin-top: calc(45% + env(safe-area-inset-top));
}

.error-text {
  height: auto;
}

.error-text {
  text-align: left;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.yellow {
  color: yellow;
}

.login-box {
  background: rgba(0, 0, 0, 0.47);
  border: 1px solid transparent;
  display: block;
  min-width: 100px;
  max-width: 400px;
  min-height: 50%;
  margin: auto;
}

ion-button::part(native) {
  left: -2px;
}

.override-margin-top {
  margin-top: calc(10% + env(safe-area-inset-top)) !important;
  transition: margin-top 0.5s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/login/login.page.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,6BAAA;AACF;;AAEA;EACE,WAAA;EACA,6BAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AACF;;AACA;EACE,eAAA;EACA,kCAAA;AAEF;;AACA;EACE,+BAAA;AAEF;;AACA;EACE,2BAAA;EACA,YAAA;AAEF;AAAE;EACE,iBAAA;EACA,oBAAA;AAEJ;AACE;EACE,+BAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AACJ;AAEE;EACE,6BAAA;EACA,4BAAA;EACA,mBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,kBAAA;AADJ;AAIE;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,WAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAKE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AAHJ;AAME;EACE,uCAAA;AAJJ;AAOE;EACE,eAAA;EACA,yBAAA;AALJ;AAQE;EACE,oCAAA;EACA,uBAAA;AANJ;AASE;EACE,cAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AARF;;AAWA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AARF;;AAWA;EACE,yBAAA;EACA,eAAA;EACA,2BAAA;AARF;;AAWA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AARF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAPF;;AAUA;EACE,4BAAA;EACA,sBAAA;AAPF;;AAUA;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAPF;;AASA;EACE,WAAA;EACA,eAAA;AANF;;AAQA;EACE,mBAAA;AALF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE;IACE,6BAAA;IACA,4BAAA;EAJF;AACF;AAMA;EACE;IACE,sBAAA;EAJF;EAMA;IACE,aAAA;EAJF;EAMA;IACE,sBAAA;EAJF;EAMA;IACE,eAAA;EAJF;EAMA;IACE,aAAA;EAJF;EAMA;IACE,WAAA;EAJF;EAOE;IACE,iBAAA;EALJ;AACF;AASA;EACE;IACE,sBAAA;EAPF;EASA;IACE,aAAA;EAPF;EASA;IACE,sBAAA;EAPF;EASA;IACE,eAAA;EAPF;EASA;IACE,aAAA;EAPF;EASA;IACE,WAAA;EAPF;EAUE;IACE,gBAAA;IACA,kBAAA;EARJ;AACF;AAYA;EACE;IACE,eAAA;EAVF;EAYA;IACE,sBAAA;EAVF;AACF;AAaA;EAEI;IACE,kBAAA;IACA,gBAAA;EAZJ;AACF;AAgBA;EACE;IACE,iBAAA;EAdF;AACF;AAiBA;EACE;IACE,iBAAA;EAfF;AACF;AAkBA;EACE;IACE,iBAAA;EAhBF;AACF;AAmBA;EACE;IACE,iBAAA;EAjBF;AACF;AAoBA;EACE;IACE,iBAAA;EAlBF;AACF;AAqBA;EACE;IACE,kBAAA;EAnBF;AACF;AAsBA;EACE;IACE,kBAAA;EApBF;AACF;AAuBA;EACE;IACE,2DAAA;EArBF;AACF;AAwBA;EACE;IACE,2DAAA;EAtBF;EAwBA;IACE,sBAAA;EAtBF;EAwBA;IACE,aAAA;EAtBF;EAwBA;IACE,sBAAA;EAtBF;AACF;AAyBA;EACE,cAAA;AAvBF;;AA0BA;EACE,qBAAA;AAvBF;;AA0BA;EACE;;IAEE,mBAAA;EAvBF;AACF;AA0BA;EACE,kBAAA;EACA,6BAAA;AAxBF;;AA2BA;EACE,aAAA;AAxBF;;AA2BA;EACE,aAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,aAAA;AAxBF;;AA2BA;EACE,iBAAA;AAxBF;;AA2BA;EACE,gDAAA;AAxBF;;AA2BA;EACE,YAAA;AAxBF;;AA2BA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAxBF;;AA2BA;EACE,aAAA;AAxBF;;AA2BA;EACE,+BAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,2DAAA;EACA,uCAAA;AAxBF","sourcesContent":["span.hoverClick:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\nbody {\r\n  background-color: #000;\r\n}\r\n\r\ninput.text-input.text-input-ios {\r\n  margin: 13px 8px;\r\n  padding: 0;\r\n  width: calc(100% - 8px - 8px);\r\n}\r\n\r\ninput.inputItem {\r\n  width: 100%;\r\n  border-radius: 2px !important;\r\n  padding-left: 5px;\r\n  border: 0px;\r\n}\r\n\r\n.login-button{\r\n  color: #ffffff;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  width: 100%;\r\n  margin-top: 8px;\r\n}\r\n.toggle-password-button {\r\n  font-size: 20px;\r\n  color: var(--ion-icon-color, #000);\r\n}\r\n\r\n.toggle-password-button:hover {\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\n.login-content {\r\n  background: rgb(32, 39, 66);\r\n  padding: 0px;\r\n\r\n  .logo-row {\r\n    padding-top: 50px;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .login-box {\r\n    background: rgba(0, 0, 0, 0.47);\r\n    border: 1px solid transparent;\r\n    margin: auto;\r\n    display: block;\r\n    min-width: 100px;\r\n    max-width: 400px;\r\n    min-height: 50%;\r\n    margin-top: -10%;\r\n    margin-right: 5%;\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  .custom-input-box {\r\n    border-radius: 5px !important;\r\n    padding-left: 5px !important;\r\n    background: #4065ac;\r\n  }\r\n\r\n  ion-row {\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n\r\n  ion-item {\r\n    font-size: 0.9em;\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ffffff;\r\n    border-bottom: 0px !important;\r\n    color: #fff;\r\n  }\r\n\r\n  .signup-col {\r\n    margin: 0px 10px 0px 10px;\r\n  }\r\n  .inputItem {\r\n    margin-top: 8px;\r\n    border-radius: 2px;\r\n    height: 40px;\r\n    color: #000000 !important;\r\n    font-size: 14px;\r\n    background: rgb(255, 255, 255);\r\n    text-align: left;\r\n  }\r\n\r\n  .item-inner {\r\n    border-bottom-color: #ffffff !important;\r\n  }\r\n\r\n  .submit-btn {\r\n    margin-top: 8px;\r\n    background-color: #bb1f2d;\r\n  }\r\n\r\n  .submit-btn:hover {\r\n    background-color: #bb1f2d !important;\r\n    opacity: 0.7 !important;\r\n  }\r\n\r\n  .register-btn {\r\n    color: #ffffff;\r\n    font-size: 0.8em;\r\n  }\r\n}\r\n\r\n.password-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.toggle-password {\r\n  position: absolute;\r\n  right: 10%;\r\n  top: 40%;\r\n  z-index: 10;\r\n  color: black;\r\n  cursor: pointer;\r\n}\r\n\r\n.loginHeader {\r\n  color: rgb(217, 231, 241);\r\n  font-size: 20px;\r\n  margin-top: 18px !important;\r\n}\r\n\r\n.loginLabel {\r\n  text-align: left;\r\n  margin-top: 15px;\r\n  font-size: 12px;\r\n}\r\n.logoLogin {\r\n  height: 40px;\r\n}\r\n\r\n.error-text {\r\n  text-align: left;\r\n  font-size: 14px;\r\n  margin-top: 5px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.contentBackground {\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.login-base-content {\r\n  width: 100%;\r\n  background-color: black;\r\n  color: white;\r\n  text-align: left;\r\n  padding: 3%;\r\n  position: fixed;\r\n  bottom: 30px;\r\n}\r\n.label1 {\r\n  color: gray;\r\n  font-size: 17px;\r\n}\r\n.scroll-content {\r\n  overflow-y: inherit;\r\n}\r\na[_ngcontent-c0] {\r\n  color: #ffffff;\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .login-box {\r\n    margin-right: 10px !important;\r\n    margin-left: 10px !important;\r\n  }\r\n}\r\n@media screen and (max-width: 415px) and (max-height: 815px) {\r\n  .login-base-content {\r\n    padding: 1% !important;\r\n  }\r\n  .login-base-content-right {\r\n    display: none;\r\n  }\r\n  .login-base-content-left {\r\n    width: 100% !important;\r\n  }\r\n  .label1 {\r\n    font-size: 12px;\r\n  }\r\n  .login-content-left {\r\n    display: none;\r\n  }\r\n  .login-content-right {\r\n    width: 100%;\r\n  }\r\n  .login-content {\r\n    .login-box {\r\n      margin-left: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 416px) and (max-width: 1024px) {\r\n  .login-base-content {\r\n    padding: 1% !important;\r\n  }\r\n  .login-base-content-right {\r\n    display: none;\r\n  }\r\n  .login-base-content-left {\r\n    width: 100% !important;\r\n  }\r\n  .label1 {\r\n    font-size: 16px;\r\n  }\r\n  .login-content-left {\r\n    display: none;\r\n  }\r\n  .login-content-right {\r\n    width: 100%;\r\n  }\r\n  .login-content {\r\n    .login-box {\r\n      margin-top: -15%;\r\n      margin-right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1025px) and (max-width: 1280px) {\r\n  .label1 {\r\n    font-size: 14px;\r\n  }\r\n  .row-style {\r\n    margin: 0px !important;\r\n  }\r\n}\r\n\r\n@media screen and (width: 1024px) and (height: 1366px) {\r\n  .login-content {\r\n    .login-box {\r\n      margin-right: auto;\r\n      max-width: 560px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 670px) {\r\n  .login-grid {\r\n    min-height: 400px;\r\n  }\r\n}\r\n\r\n@media screen and (min-height: 671px) and (max-height: 769px) {\r\n  .login-grid {\r\n    min-height: 600px;\r\n  }\r\n}\r\n\r\n@media screen and (min-height: 770px) and (max-height: 900px) {\r\n  .login-grid {\r\n    min-height: 675px;\r\n  }\r\n}\r\n\r\n@media screen and (min-height: 901px) and (max-height: 1080px) {\r\n  .login-grid {\r\n    min-height: 750px;\r\n  }\r\n}\r\n\r\n@media screen and (min-height: 1081px) and (max-height: 1200px) {\r\n  .login-grid {\r\n    min-height: 950px;\r\n  }\r\n}\r\n\r\n@media screen and (min-height: 1201px) and (max-height: 1440px) {\r\n  .login-grid {\r\n    min-height: 1000px;\r\n  }\r\n}\r\n\r\n@media screen and (min-height: 1441px) and (max-height: 2160px) {\r\n  .login-grid {\r\n    min-height: 1200px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width: 700px) and (max-device-width: 1024px) and (orientation: landscape) {\r\n  .grid-align {\r\n    margin-top: calc(20% + env(safe-area-inset-top)) !important;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {\r\n  .grid-align {\r\n    margin-top: calc(25% + env(safe-area-inset-top)) !important;\r\n  }\r\n  .login-base-content {\r\n    padding: 1% !important;\r\n  }\r\n  .login-base-content-right {\r\n    display: none;\r\n  }\r\n  .login-base-content-left {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n.lable-name {\r\n  color: #dee0e1;\r\n}\r\n\r\n.row-style {\r\n  margin: 0px 3% 0px 3%;\r\n}\r\n\r\n@media screen and (max-width: 640px) {\r\n  .ios .mobStyle,\r\n  .md .mobStyle {\r\n    margin-bottom: 30px;\r\n  }\r\n}\r\n\r\n.labelFont {\r\n  font-size: smaller;\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\n.signInImage {\r\n  height: 100px;\r\n}\r\n\r\n.header-row {\r\n  height: 150px;\r\n}\r\n\r\n.signInButton {\r\n  width: 100%;\r\n  height: 2.8em;\r\n}\r\n\r\n.form-style {\r\n  margin-bottom: 2%;\r\n}\r\n\r\n.grid-align {\r\n  margin-top: calc(45% + env(safe-area-inset-top));\r\n}\r\n\r\n.error-text {\r\n  height: auto;\r\n}\r\n\r\n.error-text {\r\n  text-align: left;\r\n  font-size: 14px;\r\n  margin-top: 5px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.yellow {\r\n  color: yellow;\r\n}\r\n\r\n.login-box {\r\n  background: rgba(0, 0, 0, 0.47);\r\n  border: 1px solid transparent;\r\n  display: block;\r\n  min-width: 100px;\r\n  max-width: 400px;\r\n  min-height: 50%;\r\n  margin: auto;\r\n}\r\n\r\nion-button::part(native) {\r\n  left: -2px;\r\n}\r\n\r\n.override-margin-top {\r\n  margin-top: calc(10% + env(safe-area-inset-top)) !important;\r\n  transition: margin-top 0.5s ease-in-out;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
